import { FORM_ID } from 'legacy/lut/classes/models/partner360/ELT/IELTData'

import { calculateFileLink } from 'core/classes/helpers/saveFiles'

import { TImages } from '../models/ImageUpload'

export const getImages = ({
  entryId,
  logo,
  picture,
  uid,
  attachment,
}: {
  entryId?: number
  logo?: string
  picture?: string
  attachment?: string
  uid?: string
}) => {
  const images: TImages = {} as TImages
  if (entryId) {
    if (logo) {
      images['Logo'] = calculateFileLink({
        formId: FORM_ID,
        entryId,
        fieldName: 'Logo',
        fileName: logo,
        UID: uid,
      })
    }

    if (picture) {
      images['Picture'] = calculateFileLink({
        formId: FORM_ID,
        entryId,
        fieldName: 'Picture',
        fileName: picture,
        UID: uid,
      })
    }

    if (attachment) {
      images['Attachment'] = calculateFileLink({
        formId: FORM_ID,
        entryId,
        fieldName: 'Attachment',
        fileName: attachment,
        UID: uid,
      })
    }
  }
  return images
}
